import React, { useState, useEffect } from 'react'
import { Routes, Route, Navigate, useLocation } from 'react-router-dom'
import MainLayout from '../Layout/Layout'
import NoHeaderLayout from '../Layout/NoHeaderLayout'
import ReactGA from 'react-ga4'

import routerUrls from '../constants/routeUrlConstants'
import { ProtectedRoute } from './ProtectedRoute'
import SingleLayout from '../Layout/SingleLayout'
import RestrictedIcon from '../assets/images/restricted.png'
import AnnouncmentIcon from '../assets/images/announcment.png'
import config from 'config/config'
const LazyLogin = React.lazy(() => import('../pages/Login'))
const LazyHome = React.lazy(() => import('../pages/Home'))
const LazyDashboard = React.lazy(() => import('../pages/Dashboard'))
const LazyMyProfile = React.lazy(() => import('../pages/MyProfile'))
const LazyMyBenefits = React.lazy(() => import('../pages/MyBenefits'))
const LazyMyNotices = React.lazy(() => import('../pages/MyNotices'))
const LazyMyDocuments = React.lazy(() => import('../pages/MyDocuments'))
const LazyMyAccounts = React.lazy(() => import('../pages/MyAccounts'))
const LazyFeedback = React.lazy(() => import('../pages/FeedbackPage'))
const LazyLanding = React.lazy(() => import('../pages/Landing'))
const LazyUserAccess = React.lazy(() => import('../pages/UserAccess'))
const LazyManageBanners = React.lazy(() => import('../pages/ManageBanners'))
const LazyUtilities = React.lazy(() => import('../pages/Utilities'))

const wrapWithLayout = (comp) => {
  return (
    <ProtectedRoute >
      <MainLayout>{comp}</MainLayout>
    </ProtectedRoute>
  )
}
const wrapWithoutHeader = (comp) => {
  return (
    <ProtectedRoute >
      <NoHeaderLayout logoClick='/landing' showProfile={true}>{comp}</NoHeaderLayout>
    </ProtectedRoute>
  )
}

const AppRoutes = () => {
  const location = useLocation()
  const [linkAccess, setLinkAccess] = useState(true)
  const UserAccess = [
    {
      name: 'useraccess',
      route: 'useraccess',
      altText: 'useraccess',
      icon: RestrictedIcon
    }
  ]

  const ManageBanners = [
    {
      name: 'manageBanners',
      route: 'banners',
      altText: 'manageBanners',
      icon: AnnouncmentIcon
    }
  ]
  const selectedLanguage = localStorage.getItem('language') ? localStorage.getItem('language') : 'en-US'
  useEffect(() => {
    ReactGA.gtag('event', 'page_view', {
      page_title: location.pathname,
      page_location: location.pathname,
      label: selectedLanguage
    })
    ReactGA.send({ hitType: 'pageview', page: location.pathname, label: `${selectedLanguage} : ${location.pathname}` })
  }, [location.pathname, selectedLanguage])
  return (
    <Routes history={history}>
      <Route
        path={routerUrls.HOME.path}
        element={
          <React.Suspense>
            <LazyHome />
          </React.Suspense>
        }
      />
      <Route
        path={routerUrls.LOGIN.path}
        element={
          <React.Suspense>
            <LazyLogin />
          </React.Suspense>
        }
      />

      <Route
        path={routerUrls.MY_PROFILE.path}
        element={
          <React.Suspense>
            {wrapWithLayout(<LazyMyProfile />)}
          </React.Suspense>
        }
      />
      <Route
        path={routerUrls.MY_BENEFITS.path}
        element={
          <React.Suspense>
            {wrapWithLayout(<LazyMyBenefits />)}
          </React.Suspense>
        }
      />
      <Route
        path={routerUrls.MY_NOTICES.path}
        element={
          <React.Suspense>
            {wrapWithLayout(<LazyMyNotices />)}
          </React.Suspense>
        }
      />

      <Route
        path={routerUrls.MY_ACCOUNTS.path}
        element={
          <React.Suspense>
            {wrapWithLayout(<LazyMyAccounts />)}
          </React.Suspense>
        }
      />
        <Route
        path={routerUrls.FEEDBACK_LANDING.path}
        element={
          <React.Suspense>
            {wrapWithoutHeader(<LazyFeedback />)}
          </React.Suspense>
        }
      />
      {config.featureToggle.utilityDiscountProgram && <Route
        path={routerUrls.UTILITIES.path}
        element={
          <React.Suspense>
            {<LazyUtilities></LazyUtilities>}
          </React.Suspense>
        }
      />}
        <Route
        path={routerUrls.FEEDBACK.path}
        element={
          <React.Suspense>
            {wrapWithLayout(<LazyFeedback />)}
          </React.Suspense>
        }
      />
      <Route
        path={routerUrls.MY_DOCUMENTS.path}
        element={
          <React.Suspense>
            {wrapWithLayout(<LazyMyDocuments />)}
          </React.Suspense>
        }
      />
      <Route
        path={routerUrls.LANDING.path}
        element={
          <React.Suspense>
            <ProtectedRoute>
              <LazyLanding />
            </ProtectedRoute>
            {}
          </React.Suspense>
        }
      />
      <Route
        path={routerUrls.USER_ACCESS.path}
        element={
          <React.Suspense>
            <ProtectedRoute >
              <SingleLayout item={UserAccess}>
                <LazyUserAccess />
              </SingleLayout>
            </ProtectedRoute>
          </React.Suspense>
        }
      />
      <Route
        path={routerUrls.MANAGE_BANNERS.path}
        element={
          <React.Suspense>
            <ProtectedRoute >
              <SingleLayout item={ManageBanners}>
                <LazyManageBanners />
              </SingleLayout>
            </ProtectedRoute>
          </React.Suspense>
        }
      />
      <Route
        path={routerUrls.DASHBOARD.path}
        element={
          <React.Suspense>
            {wrapWithLayout(<LazyDashboard access={linkAccess} linkAccountFunc={(status) => { setLinkAccess(status) }} />)}
          </React.Suspense>
        }
      />
      <Route
        path='/'
        element={
          <React.Suspense>
            <LazyHome />
          </React.Suspense>
        }
      />
      <Route
        path="*"
        element={<Navigate to="/" replace />}
      />
    </Routes>
  )
}

export default AppRoutes
